module.exports = __webpack_public_path__ + "img/group-people.7b5ff3ea.svg";